import React from 'react';
import { motion } from 'framer-motion';
import valueLoveCraft from '../assets/careers/value-love-craft.jpg';
import valueGrow from '../assets/careers/value-grow.jpg';
import valueCommunity from '../assets/careers/value-community.jpg';

const CareersValuesSection: React.FC = () => {
  const values = [
    {
      title: 'Build community',
      description: 'Sunt sit proident commodo excepteur proident non cupidatat cillum eu minim',
      image: valueCommunity,
      imageStyle: { height: '250.55%', top: '-89.56%' }
    },
    {
      title: 'Love your craft',
      description: 'Sunt sit proident commodo excepteur proident non cupidatat cillum eu minim',
      image: valueLoveCraft,
      imageStyle: { height: '111.54%', top: '-5.49%' }
    },
    {
      title: 'Grow as you go',
      description: 'Sunt sit proident commodo excepteur proident non cupidatat cillum eu minim',
      image: valueGrow,
      imageStyle: { height: '134.62%', left: '-20.72%', top: '-31.87%', width: '120.72%' }
    }
  ];

  return (
    <section className="relative bg-[#fafafb] py-16 lg:py-20">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-open-sans font-bold text-[52px] leading-[74px] text-[#323743] text-center mb-16"
          style={{ fontVariationSettings: "'wdth' 100" }}
        >
          Our values
        </motion.h2>

        {/* Values Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-[960px] mx-auto">
          {values.map((value, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-[18px] overflow-hidden shadow-card"
              style={{ height: '342px' }}
            >
              {/* Image */}
              <div className="relative w-full h-[182px] overflow-hidden">
                <img
                  src={value.image}
                  alt={value.title}
                  className="absolute w-full object-cover"
                  style={value.imageStyle}
                />
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="font-open-sans font-bold text-[20px] leading-[30px] text-[#323743] mb-4" style={{ fontVariationSettings: "'wdth' 100" }}>
                  {value.title}
                </h3>
                <p className="font-manrope font-normal text-[16px] leading-[26px] text-[#171a1f]">
                  {value.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CareersValuesSection;
